import { Injectable } from '@angular/core';
import { HttpService } from '../../../core/services/http/http.service';
import { Store } from '@ngrx/store';
import { AppState} from 'src/store/reducers';
import { ViewOffer,ChangeOfferStatus} from 'src/store/actions/offerActions';
@Injectable({
  providedIn: 'root'
})
export class ViewoffersService {

  constructor(private http: HttpService,private store: Store<AppState>) { }

  viewAllOffers(id,range){
    return this.http.query('get', 'all-requests/'+id + '?'+ range, {});
  }
  dispatchOfferAction(id,payload) {
    this.store.dispatch(new ViewOffer(id,payload));
  }
  offerStatusChange(id,payload){
    return this.http.query('post', 'change-request-status/'+id, {},'',payload);
  }
  dispatchOfferStatusAction(id,payload) {
    this.store.dispatch(new ChangeOfferStatus(id,payload));
  }
}